export const unsupportedStates = ['CT', 'IA', 'NH', 'WV', 'VT'];

export const unsupportedStatesDPOnly = ['WV', 'VT'];
